export const environment = {
    production: false,
    enableDevToolsBlocker: false,
    baseUrl: "http://localhost:4200",
    apiUrl: "https://tco1p-dev-cvx.azurewebsites.net",
    // apiUrl: "https://localhost:7221",
    autoSignIn: true,
    popupForLogin: false,
    cacheLocation: "localStorage",
    instance: "https://login.microsoftonline.com/",
    tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    clientId: "b4f22226-8be1-4929-bad0-548376b52019",
    redirectUri: "https://oneportfolio-dev.tengizchevroil.com",
    // redirectUri: "http://localhost:4200",
    oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
    graphScopes: ["User.Read", "User.Read.All"],
    scopeUrl: "https://tco1p-test.tengizchevroil.com/user_impersonation",
    oldUrl: "tco1p-dev-fe-cvx.azurewebsites.net",
    newUrl: "oneportfolio-dev.tengizchevroil.com"
}
